import { connect } from 'react-redux'
import MapMessage from './MapMessage'
import { isNoInternet, isToZoomedOut, isLoadLightError } from '../../selectors/latestLoadLightError'

const mapStateToProps = (state, ownProps) => ({
	message: mapMessage(state)
})

const mapMessage = (state) => {
	if (state.pendingRequestCount !== 0) {
		return "Laddar punkter..."
	}
	else if (isNoInternet(state)) {
		return "Inte ansluten till internet."
	}
	else if (isToZoomedOut(state)) {
		return "Zooma in för att visa punkter."
	}
	else if (isLoadLightError(state)) {
		return "Kunde inte hämta punkter."
	}
	else {
		return undefined
	}
}

const mapDispatchToProps = (dispatch, ownProps) => ({})

export default connect(mapStateToProps, mapDispatchToProps)(MapMessage);


// WEBPACK FOOTER //
// ./src/components/MapMessage/MapMessageContainer.js